import { sitePath, WORKS_GALLERY_PATH, INSIGHTS_HUB_PATH } from '@/lib/site-urls';

export function LandingFooter() {
  return (
    <footer className="footer-7">
      <div className="footer-7-container">
        <div className="footer-7-top">
          <div className="footer-7-brand">
            <div className="footer-7-logo">
              <h2 className="footer-7-logo-title">
                <span className="brand-code">
                  <span className="brand-paren">thinkinCode(</span>
                  <img className="footer-7-logo-img brand-emblem" src="/thinkincode-logo.png" alt="ThinkinCode emblem" />
                  <span className="brand-paren">);</span>
                </span>
              </h2>
            </div>
            <p className="footer-7-desc">
              Premium digital systems, websites, and platforms - designed with precision, built to scale.
            </p>
            <ul className="footer-7-social" aria-label="Social links">
              <li>
                <a
                  className="footer-7-social-link"
                  href="https://www.instagram.com/thinkincode.co.za/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  className="footer-7-social-link"
                  href="https://www.facebook.com/profile.php?id=61555149453443"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
                    <path d="M18 2 h-3 a5 5 0 0 0 -5 5 v3 H7 v4 h3 v8 h4 v-8 h3 l1 -4 h-4 V7 a1 1 0 0 1 1 -1 h3 z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  className="footer-7-social-link"
                  href="https://x.com/thinkincode_ZA"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="X"
                >
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  className="footer-7-social-link"
                  href="https://api.whatsapp.com/send/?phone=27665733031&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                >
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  className="footer-7-social-link"
                  href="https://www.tiktok.com/@thinkincode?_r=1&_t=ZS-95YthLh3znA"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="TikTok"
                >
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
                    <path d="M17.7 7.6c-1.1-.7-1.9-1.8-2.1-3.2V3h-3.2v12.2a2.7 2.7 0 1 1-2.2-2.7c.3 0 .5 0 .8.1V9.4a6 6 0 1 0 6 6V9.1c1.1.8 2.5 1.3 4 1.3V7.2c-1.2 0-2.4-.3-3.3-.9Z" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-7-sections">
            <div className="footer-7-col">
              <h3 className="footer-7-col-title">Product</h3>
              <ul className="footer-7-links">
                <li>
                  <a href={sitePath('/portfolio')}>Portfolio</a>
                </li>
                <li>
                  <a href={sitePath('/services')}>Services</a>
                </li>
                <li>
                  <a href={sitePath('/contact')}>Start a project</a>
                </li>
                <li>
                  <a href={sitePath('/contact')}>Request a quote</a>
                </li>
              </ul>
            </div>
            <div className="footer-7-col">
              <h3 className="footer-7-col-title">Company</h3>
              <ul className="footer-7-links">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href={sitePath('/about')}>About</a>
                </li>
                <li>
                  <a href={sitePath('/services')}>What we do</a>
                </li>
                <li>
                  <a href={WORKS_GALLERY_PATH}>Interactive Gallery</a>
                </li>
                <li>
                  <a href={sitePath('/contact')}>Contact</a>
                </li>
              </ul>
            </div>
            <div className="footer-7-col">
              <h3 className="footer-7-col-title">Resources</h3>
              <ul className="footer-7-links">
                <li>
                  <a href={INSIGHTS_HUB_PATH}>Insights</a>
                </li>
                <li>
                  <a href={sitePath('/contact')}>Email us</a>
                </li>
                <li>
                  <a
                    href="https://api.whatsapp.com/send/?phone=27665733031&text&type=phone_number&app_absent=0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    WhatsApp
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-7-bottom">
          <p className="footer-7-copy">
            © <span id="footer-year">2026</span> ThinkinCode. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
